<!----------------------- Компонент логіну --------------------->
<template>
  <div id="login" class="login-page" ref="loginRef">
    <div id="loginContainerBox" class="login-left">
      <div class="left-content">
        <div class="header-login">
          <headloginreg @clickLogo="devMode()" />
          <!-- Мова -->
          <div class="langSelector">
            <SelectLangs @changeLang="changeLang($event)" />
          </div>
        </div>
        <choiceCompany v-if="showChoiceCompanyForm"></choiceCompany>
        <div class="reg-block-container">
          <!-- Звичайна форма логіна -->
          <div class="login-container">

            <div class="login-form-container">
              <!-- КЕП ще не прив'язаний: входимо як раніше — і прив'язуємо в goToCabinet -->
              <div v-if="kepPending.ticket" class="kep-pending">
                <span>{{ kepPendingText }}</span>
                <span class="kep-pending-actions">
                  <span class="kep-pending-link" @click="showLoginServiceKep = true">{{ lang['KepNewAccount'] }}</span>
                  <span class="kep-pending-close" @click="setKepPending()" aria-label="close">&times;</span>
                </span>
              </div>
              <div>
                <label for="login" class="enter-text" v-html="lang['EntrWidthEmailOrPhone']"></label>
                <b-form-input :state="loginState" type="email" v-model="form.login" name="login" id="person_login_input"
                  ref="loginInput" :disabled="showLoginPass" class="input" :placeholder="lang['LoginPlaceholder']" />
              </div>

              <button class="btn loginButton" @click="btnLogin">
                {{ lang['login'] }}
              </button>
            </div>
          </div>

          <!-- ↓↓↓ СОЦ МЕРЕЖІ ЗНИЗУ ↓↓↓ -->

          <div class="network-reg">
            <div id="enterWidth" class="enter-with-text">
              <span>{{ lang['EnterWidth'] }}</span>
            </div>

            <div class="network-div-container">
              <div class="network-div" v-if="false">
                <button class="btn" @click="facebookLogin" aria-label="facebook login">
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="#1876d2" class="network-img"
                    viewBox="0 0 80 80">
                    <path fill="var(--base-blue)" fill-rule="evenodd"
                      d="M80 40C80 17.908 62.092 0 40 0S0 17.908 0 40c0 19.975 14.642 36.528 33.778 39.517V51.556H23.556V40h10.222l.006-8.812c0-10.025 5.938-15.586 15.075-15.586 4.376 0 8.919.842 8.919.842v9.778h-5.01c-4.968 0-6.555 3.111-6.555 6.275l.01 7.503h11.11l-1.777 11.556h-9.334v27.961C65.36 76.528 80 59.975 80 40"
                      clip-rule="evenodd" />
                    <path fill="#fff" fill-rule="evenodd"
                      d="M55.556 51.555 57.333 40h-11.11l-.01-7.503c0-3.164 1.587-6.275 6.555-6.275h5.01v-9.778s-4.543-.842-8.92-.842c-9.136 0-15.074 5.56-15.074 15.585L33.778 40H23.555v11.555h10.223v27.962a40.27 40.27 0 0 0 12.444 0V51.555h9.334Z"
                      clip-rule="evenodd" />
                  </svg> </button>
              </div>
              <div class="network-div">
                <button class="btn" @click="googleLogin" aria-label="google login">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="50" class="network-img"
                    viewBox="0 0 24 24">
                    <path fill="#4285F4"
                      d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
                    <path fill="#34A853"
                      d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                    <path fill="#FBBC05"
                      d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                    <path fill="#EA4335"
                      d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                    <path fill="none" d="M1 1h22v22H1z" />
                  </svg>
                </button>
              </div>
              <div v-if="telegramServiceEnable" class="network-div">
                <button class="btn" @click="telegramLogin" aria-label="telegram login">
                  <svg class="network-img" xmlns="http://www.w3.org/2000/svg" width="36" height="50" fill="#2aabee"
                    viewBox="0 0 16 16">
                    <path
                      d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.287 5.906c-.778.324-2.334.994-4.666 2.01-.378.15-.577.298-.595.442-.03.243.275.339.69.47l.175.055c.408.133.958.288 1.243.294.26.006.549-.1.868-.32 2.179-1.471 3.304-2.214 3.374-2.23.05-.012.12-.026.166.016.047.041.042.12.037.141-.03.129-1.227 1.241-1.846 1.817-.193.18-.33.307-.358.336a8.154 8.154 0 0 1-.188.186c-.38.366-.664.64.015 1.088.327.216.589.393.85.571.284.194.568.387.936.629.093.06.183.125.27.187.331.236.63.448.997.414.214-.02.435-.22.547-.82.265-1.417.786-4.486.906-5.751a1.426 1.426 0 0 0-.013-.315.337.337 0 0 0-.114-.217.526.526 0 0 0-.31-.093c-.3.005-.763.166-2.984 1.09z" />
                  </svg>
                </button>
              </div>
              <div v-if="appleSign" class="network-div" aria-label="apple login">
                <button class="btn" @click="signInWithApple">
                  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" width="36" height="50" class="apple-btn"
                    viewBox="0 0 22.773 22.773">
                    <path
                      d="M15.769 0h.162c.13 1.606-.483 2.806-1.228 3.675-.731.863-1.732 1.7-3.351 1.573-.108-1.583.506-2.694 1.25-3.561C13.292.879 14.557.16 15.769 0zm4.901 16.716v.045c-.455 1.378-1.104 2.559-1.896 3.655-.723.995-1.609 2.334-3.191 2.334-1.367 0-2.275-.879-3.676-.903-1.482-.024-2.297.735-3.652.926h-.462c-.995-.144-1.798-.932-2.383-1.642-1.725-2.098-3.058-4.808-3.306-8.276v-1.019c.105-2.482 1.311-4.5 2.914-5.478.846-.52 2.009-.963 3.304-.765.555.086 1.122.276 1.619.464.471.181 1.06.502 1.618.485.378-.011.754-.208 1.135-.347 1.116-.403 2.21-.865 3.652-.648 1.733.262 2.963 1.032 3.723 2.22-1.466.933-2.625 2.339-2.427 4.74.176 2.181 1.444 3.457 3.028 4.209z"
                      data-original="#000000" />
                  </svg>
                </button>
              </div>
              <!-- КЕП: кожен спосіб окремою кнопкою (віджет DSTUcrypt одразу з потрібним провайдером) -->
              <div class="network-div">
                <button class="btn" @click="kepLogin('diia')" title="Дія" aria-label="Дія">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="50" class="network-img" viewBox="0 0 96 96">
                    <path fill="#000"
                      d="M48 96C21.12 96 13.8831 94.6412 7.62092 88.3791C1.32923 82.0726 0 74.88 0 48C0 21.12 1.35877 13.9274 7.62092 7.62092C13.8831 1.35877 21.12 0 48 0C74.88 0 82.1169 1.35877 88.3791 7.62092C94.6708 13.9274 96 21.12 96 48C96 74.88 94.6708 82.0726 88.3791 88.3791C82.1169 94.6412 74.88 96 48 96Z" />
                    <path fill="#fff"
                      d="M66.8308 47.9556C64.9994 47.9556 63.8031 46.7445 63.8031 44.9574C63.8031 43.1999 65.0142 42.0036 66.8308 42.0036H71.616V47.9556H66.8308ZM75.6185 38.5476H66.3582C62.4296 38.5476 59.7416 41.1174 59.7416 44.8097C59.7416 47.734 61.4105 49.9494 64.0542 50.7174L59.0031 58.4122H63.4782L68.0271 51.4116H71.6013V58.4122H75.6185V38.5476ZM25.5213 43.7611V37.7648H33.3047V54.7642H23.5422C24.5908 52.9328 25.5213 48.694 25.5213 43.7611ZM37.4253 33.9248H21.5484V43.9236C21.5484 49.019 20.6474 52.9919 19.4511 54.779H17.5459V63.8473H21.4745V58.486H36.3324V63.8473H40.261V54.779H37.4253V33.9248ZM49.4031 55.0448L49.0487 54.8085L53.6862 38.5476H44.3077L43.3034 42.166L48.7533 42.1217L45.2087 54.5279C44.5884 56.7876 46.1096 58.8848 48.5908 58.8848C49.3736 58.8848 50.1416 58.6928 50.9982 58.1464L57.3785 53.8337L55.429 50.9537L49.4031 55.0448ZM52.1207 34.811C54.0997 34.811 54.9268 34.0725 54.9268 32.315C54.9268 30.4836 54.0702 29.7451 52.1207 29.7451C50.1711 29.7451 49.3145 30.4836 49.3145 32.315C49.3293 34.0725 50.1416 34.811 52.1207 34.811Z" />
                  </svg>
                </button>
              </div>
              <div class="network-div">
                <button class="btn" @click="kepLogin('smartid')" title="ПриватБанк" aria-label="ПриватБанк">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="50" class="network-img"
                    viewBox="142.2 142.8 142.8 142.8">
                    <path fill="#4EA524"
                      d="M255.5,172.3V256h-11.4c-4.9-41.4-30.9-67.4-72.4-72.4v-11.4H255.5z M142.2,142.8v69.5H157c38.8,0,58.5,19.7,58.5,58.6v14.8H285V142.8H142.2z" />
                    <rect x="142.2" y="229.7" width="55.8" height="55.9" fill="#1A1A18" />
                  </svg>
                </button>
              </div>
              <div class="network-div">
                <button class="btn" @click="kepLogin('file')" :title="lang['KepFile']" :aria-label="lang['KepFile']">
                  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="50" class="network-img kep-key" viewBox="0 0 24 24"
                    fill="none" stroke="#434343" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path
                      d="M16.555 3.843l3.602 3.602a2.877 2.877 0 0 1 0 4.069l-2.643 2.643a2.877 2.877 0 0 1 -4.069 0l-.301 -.301l-6.558 6.558a2 2 0 0 1 -1.239 .578l-.175 .008h-1.172a1 1 0 0 1 -.993 -.883l-.007 -.117v-1.172a2 2 0 0 1 .467 -1.284l.119 -.13l.414 -.414h2v-2h2v-2l2.144 -2.144l-.301 -.301a2.877 2.877 0 0 1 0 -4.069l2.643 -2.643a2.877 2.877 0 0 1 4.069 0z" />
                    <path d="M15 9h.01" />
                  </svg>
                </button>
              </div>
            </div>
          </div>

          <!-- Перейти до реєстрації або демо версію -->
          <div class="registration-demo">
            <div class="go-registration"> {{ lang['NoAkkGoRegText'] }}
              <span @click="goReg" class="go-registration-link">
                {{ lang['NoAkkGoReg'] }}
              </span>
            </div>

            <span @click="goDemo" class="demo-span">
              {{ lang['DemoLogin'] }}
            </span>

            <span v-if="showEmergencyEntrance > 4" @click="goEmergencyEntrance" class="emergency-entrance-span">
              {{ lang['EmergencyEntrance'] }}
            </span>
          </div>

          <!-- <vue-telegram-login 
          mode="redirect" 
          telegram-login="SkyserviceAuthbot" 
          redirect-url="https://auth.skyservice.online/" /> -->

          <div id="footerLinks">
            <a class="privacy-policy-term" href="/privacy-policy">
              <span>{{ lang['PrivacyPolicy'] }}</span>
            </a>
            <a href="/terms-of-use" class="privacy-policy-term">
              <span>{{ lang['TermOfUse'] }}</span>
            </a>
            <a href="/cookie-policy" class="privacy-policy-term">
              <span>{{ currentLang === 'ru' ? 'Политика Cookies' : currentLang === 'uk' ? 'Політика Cookies' : 'Cookie Policy' }}</span>
            </a>
            <a href="/dpa" class="privacy-policy-term">
              <span>{{ currentLang === 'ru' ? 'DPA' : currentLang === 'uk' ? 'DPA' : 'DPA' }}</span>
            </a>
          </div>

        </div>
      </div>
    </div>
    <div class="login-right">
      <div class="right-content">
        <h1 id="loginTitle" class="title">{{ lang['loginTitle'] }}</h1>
        <img class="image" src="@/assets/mockup.png">
        <div class="design-element"></div>
        <p id="loginDescr" class="content-text">{{ lang['loginDescr'] }}</p>
      </div>
    </div>

    <!-- Компонент введення та перевірки пароля для авторизації -->
    <loginPassword v-if="showLoginPass" @close="closeLoginPass()" @sendPass="sendPass" @goToCaptch="goToCaptch"
      :registered="this.registered" :personLogin="form.login"></loginPassword>

    <!-- Авторизація за допомогою Google, Facebook, Telegram, Apple -->
    <loginServicesGoogle v-if="showLoginServiceGoogle || showGoogleAndroid" @close="closeGoogleModal()"
      :serviceGoogleToken="serviceGoogleToken"></loginServicesGoogle>

    <loginServicesFB v-if="showLoginServiceFacebook || showFacebookAndroid" @close="closeFacebookModal()"
      :serviceFbId="serviceFacebookUserID" :serviceFbToken="serviceFacebookToken"></loginServicesFB>

    <loginServicesTg v-if="showLoginServiceTelegram || showTelegramAndroid" @goToAuth="openAuthModal($event)"
      @close="closeTelegramModal()" :serviceTgData="serviceTgData"></loginServicesTg>

    <loginServicesApple v-if="showLoginServiceApple" @goToAuth="openAuthModal($event)" @close="closeAppleModal()"
      :serviceAppleToken="serviceAppleToken"></loginServicesApple>

    <!-- КЕП не прив'язаний: реєстрація за номером або прив'язка до існуючого акаунта -->
    <loginServicesGoogle v-if="showLoginServiceKep" @close="closeKepModal()" :serviceName="lang['Kep']"
      :serviceKepTicket="kepPending.ticket"></loginServicesGoogle>

    <!-- Прив'язка соціальних мереж якщо є пошта користувача -->

    <continueBindSocials v-if="showBindSocials" @close="closeBindModal()" :bindData="bindData"></continueBindSocials>

    <!-- якщо користувач логінівся через телефон і при цьому забув пароль, то після натискання - "Забув пароль"
          викликаємо модалку з капчею і після цього смс  -->
    <forgotcaptcha :personLogin="form.login" v-if="showForgotCaptcha" @getSms="getSms" @close="closeCaptcha()" />
    <!-- Компонент отримання смс -->
    <sms :personLogin="form.login" v-if="showSms" @close="closeSmsModal()" />
    <!-- Компонент отримання смс -->
    <sms :personLogin="form.login" v-if="showSms" @close="closeSmsModal()" />
    <!-- Компонент кнопки для чату на старих андроїдах -->
    <CrispChatButton v-if="showCrispButton" @close="showCrispButton = false" />
  </div>
</template>

<script>
import { store } from "@/store.js"; // Глобальне сховище даних
import { keyevent } from '@/main.js'; // Імпорт глобального об'єкта keyevent для обміну подіями між компонентами
import { webviewCheck } from "../js/webviewCheck"; // Імпортуємо функцію для перевірки типу веб-переглядача (WebView)
import SelectLangs from '../LangSelectComponent.vue'; // Компонент випадаючого списку для вибору мови
import forgotcaptcha from "./forgotCaptcha"; // Компонент для виводу капчі, якщо користувач забув пароль
import sms from "./getSMS"; // Компонент для вводу смс, якщо користувач забув парол
import loginPassword from "./loginPassword.vue"; // Компонент вводу пароля користувача
import loginServicesApple from "./loginServicesApple.vue"; // Модальне вікно авторизації через Apple
import loginServicesFB from "./loginServicesFB.vue"; // Модальне вікно авторизації через Facebook
import loginServicesGoogle from "./loginServicesGoogle.vue"; // Модальне вікно авторизації через Google
import loginServicesTg from "./loginServicesTg.vue"; // Модальне вікно авторизації через Telegram
import continueBindSocials from "./continueBindSocials.vue";
import { signKepChallenge, isKepSilentError } from "../js/kep"; // Вхід за КЕП через віджет DSTUcrypt
import headloginreg from "../heads/HeaderLoginAndReg"; // Компонент хедеру з логотипом
import Cookies from 'js-cookie'; // Модуль для роботи з кукі
import CrispChatButton from "@/components/CrispChatButton.vue" // компонент нативной кнопки чата для старых андроидов
import choiceCompany from '@/components/choiceCompany/choiceCompany.vue'; // Модальне вікно вибору компаній
import { MoreURL } from "@/API.js";
const moreURLs = new MoreURL();

import { regAPi } from "@/API.js";
const apiList = new regAPi();

// Створюємо апі куків з налаштуванням дефолтного домен для продакшену
let apiCookies = Cookies;
if (process.env.NODE_ENV == 'production') {
  apiCookies = Cookies.withAttributes({ domain: ".skyservice.online" })
}
export default {
  components: {
    SelectLangs,
    loginPassword,
    headloginreg,
    loginServicesFB,
    loginServicesGoogle,
    loginServicesTg,
    continueBindSocials,
    sms,
    forgotcaptcha,
    CrispChatButton,
    loginServicesApple,
    choiceCompany
  },
  data() {
    return {
      showChoiceCompanyForm: false,
      closeTest: false,
      registered: null,
      showEmergencyEntrance: 0,
      form: {
        login: "",
        password: "",
      },
      google: 'google',
      facebook: 'facebook',
      telegram: 'telegram',
      serviceTgData: {},
      showLoginServiceGoogle: false,
      showLoginServiceFacebook: false,
      showLoginServiceTelegram: false,
      showLoginServiceApple: false,
      showLoginServiceKep: false,
      kepPending: { ticket: '', name: '' }, // КЕП, який прив'яжемо після входу іншим способом
      kepPendingTimer: null,
      showLoginPass: false,
      showForgotCaptcha: false,
      showSms: false,
      googleClient: null,
      telegramServiceEnable: false,
      bindData: {
        socialType: '',
        currentAccessToken: '',
        currentUserPhone: '',
        facebookId: '',
        facebookToken: ''
      },
      showBindSocials: false,
      showCrispButton: false,
      // test: 'test commit'
    };
  },
  created() {
    // вимикаємо соціальні мережі (тимчасово)

    //              google 	telegram 	facebook	
    // Браузер	      1	       1	       0	
    // Android   	    1	       0	       0	
    // Windows   	    1	       1	       0	
    // ios           	1	       0	       0	

    // Слухачі для авторизації через apple для ios додатків
    window.ioshttpsender = {
      AppleIDSignInOnSuccess: (response) => {
        try {
          const responseData = JSON.parse(response)
          const appleToken = responseData.identityToken;
          this.addApple(appleToken)
        } catch (err) {
          window.say.messageError(this.lang['ErrorAppleLogin']);
        }
      },
      AppleIDSignInOnFailure: (error) => {
        console.error(error);
        window.say.messageError(this.lang['notGetDataFromApple']);
      },
      // Отримання і встановлення версії додатку IOS
      setAppVersion(appData) {
        let data = JSON.parse(appData)
        const { osVersion, deviceModel, appVersion } = data
        store.appInfoData = {
          os: osVersion,
          appVersion: appVersion,
          device: deviceModel
        }
      }
    }

    if (webviewCheck() == "android_webview") {
      this.telegramServiceEnable = false;
    } else if (webviewCheck() == "cef_webview") {
      this.telegramServiceEnable = true;
    } else if (webviewCheck() == "ios_webview") {
      this.telegramServiceEnable = false;
    } else {
      this.telegramServiceEnable = true;
    }
    // androidFixMono('login');
    // При повторному вході на сторінку авторизації якщо є токен авторизації то видаємо список компаній або редіректим на едину доступну компанію
    let startToken = Cookies.get("token")
    if (startToken) {
      /* eslint-disable */
      if (process.env.NODE_ENV != 'production') {
        //Якщо це режим розробки то кожен раз затираємо токен
        Cookies.set(`token`, '', { expires: -1 });
        //this.goToCabinet(startToken);
      } else {
        this.goToCabinet(startToken);
      }
    }

    // Замінюємо стару змінну на нову
    var registerPhoneLocal = localStorage["registration_phone"];
    if (registerPhoneLocal != null) {
      localStorage["user_login"] = registerPhoneLocal;
      localStorage.removeItem('registration_phone');
    }

    var newRegisterPhoneLocal = localStorage["user_login"];
    if (newRegisterPhoneLocal != null && newRegisterPhoneLocal !="undefined") {
      this.form.login = newRegisterPhoneLocal;
    }


    /******/

    // Метод авторизації вінда
    window.windowsAuthResult = {}
    window.windowsAuthResult.success = (json) => {
      console.log('windowsAuthResult json ->', json)
      let data = JSON.parse(json)
      if (data.authType == "google") {
        if (data.googleUser) {
          console.log('googleUser go')
          let obj = {
            lang: store.lang,
            token: data.googleUser.tokenId
          }
          store.serviceGoogleToken = data.googleUser.tokenId;
          apiList.authGoogle(obj).then((resp) => {
            if (resp.data.status == "done") {
              if (resp.data.data.token) {
                this.goToCabinet(resp.data.data.token);
              } else if (resp.data.data.description === "Email is already registered") {
                this.showBindSocials = true;
                this.bindData = {
                  socialType: "Google",
                  currentUserPhone: resp.data.data.user_phone,
                  currentAccessToken: obj.token
                }
              }
            } else {
              if (resp.data.error == "Google Acc not exist") {
                window.say.messageError(this.lang['AccountNotRegistered']);
                this.showLoginServiceGoogle = true;
              } else if (resp.data.error == "Phone is already registered") {
                this.showLoginServiceGoogle = true;
                window.say.messageError(this.lang['PhoneAlreadyRegistered']);
              } else {
                window.say.messageError(this.lang['Error']);
              }
            }
          });
        }
      } else if (data.authType == "facebook") {
        let obj = {
          id: data.facebookUser.id,
          token: data.facebookUser.token,
          lang: store.lang,
        };
        store.serviceFacebookToken = data.facebookUser.token;
        store.serviceUserID = data.facebookUser.id;
        apiList.authFB(obj).then((resp) => {
          console.log('FacebookUser request')
          if (resp.data.status == "done") {

            if (resp.data.data.description == "Email is already registered") {
              this.showBindSocials = true;
              this.bindData = {
                socialType: "Facebook",
                currentUserPhone: resp.data.data.user_phone,
                facebookToken: obj.token,
                facebookId: obj.id
              }
            } else {
              console.log('FacebookUser request done')
              this.goToCabinet(resp.data.data.token);
            }
          } else {
            console.log('FacebookUser request err')
            console.log('obj', obj)
            console.log('resp.data.error - ', resp.data.error)
            if (resp.data.error == "FB Acc not exist") {
              console.log('FacebookUser request err FB Acc not exist')
              window.say.messageError(this.lang['AccountNotRegistered'])
              this.showLoginServiceFacebook = true
            } else {
              console.log('err err')
              window.say.messageError(this.lang['ErrorFacebookLogin"']);
            }
          }
        });
      } else if (data.authType == "telegram"){
        this.telegramCallbackFunction(data.telegramUser);
      }
      console.log('end')
    }
    window.windowsAuthResult.error = () => {
      // alert('error')
    }


    window.iosGoogleAuthResult = {}
    window.iosGoogleAuthResult.success = (token) => {
      let authObj = {
        authType: "google",
        googleUser: {
          tokenId: token
        }
      }
      window.androidAuthResult.success(JSON.stringify(authObj));
    }

    window.iosFacebookAuthResult = {}
    window.iosFacebookAuthResult.success = (jsonString) => {
      let jsonObj = JSON.parse(jsonString)
      try {
        let authObj = {
          authType: "facebook",
          facebookUser: {
            userID: jsonObj.userID,
            accessToken: jsonObj.accessToken
          }
        }
        window.androidAuthResult.success(JSON.stringify(authObj));
      } catch (err) {
        // console.error(err)
      }

    }

    // Функція для авторизації андроїдів
    window.androidAuthResult = {}
    window.androidAuthResult.success = (json) => {
      let data = JSON.parse(json)
      let obj = {}
      // Гугл
      if (data.authType == 'google') {
        obj = {
          lang: store.lang,
          token: data.googleUser.tokenId
        }
        store.serviceGoogleToken = data.googleUser.tokenId;
        apiList.authGoogle(obj).then((resp) => {
          if (resp.data.status == "done") {
            if (resp.data.data.token) {
              this.goToCabinet(resp.data.data.token);
            } else if (resp.data.data.description === "Email is already registered") {
              this.showBindSocials = true;
              this.bindData = {
                socialType: "Google",
                currentUserPhone: resp.data.data.user_phone,
                currentAccessToken: obj.token
              }
            }
          } else {
            if (resp.data.error == "Google Acc not exist") {
              window.say.messageError(this.lang['AccountNotRegistered']);
              this.showLoginServiceGoogle = true;
            } else if (resp.data.error == "Phone is already registered") {
              this.showLoginServiceGoogle = true;
              window.say.messageError(this.lang['PhoneAlreadyRegistered']);
            } else {
              window.say.messageError(this.lang['Error']);
            }
          }
        });
        // Телеграм
      } else if (data.authType == 'telegram') {
        let user
        data.telegramUser = user
        obj = {
          lang: store.lang,
          ...user
        }
        apiList.authTelegram(obj).then((resp) => {
          if (resp.data.status == "done") {
            this.goToCabinet(resp.data.data.token);
          } else {
            if (resp.data.error == "Telegram acc is not registered") {
              window.say.messageError(this.lang['AccountNotRegistered']);
              store.showTelegramAndroid = true
            } else {
              window.say.messageError(this.lang['ErrorTelegramLogin']);
            }
          }
        });
        // Facebook
      } else if (data.authType == 'facebook') {
        obj = {
          id: data.facebookUser.userID,
          token: data.facebookUser.accessToken,
          lang: store.lang,
        }
        store.serviceFacebookToken = data.facebookUser.accessToken
        store.serviceUserID = data.facebookUser.userID
        apiList.authFB(obj).then((resp) => {
          if (resp.data.status == "done") {
            if (resp.data.data.description == "Email is already registered") {
              this.showBindSocials = true;
              this.bindData = {
                socialType: "Facebook",
                currentUserPhone: resp.data.data.user_phone,
                facebookToken: obj.token,
                facebookId: obj.id
              }
            } else if (resp.data.data.token) {
              this.goToCabinet(resp.data.data.token);
            } else {
              window.say.messageError(this.lang['Error'] + ": 1101");
            }

          } else {
            if (resp.data.error == "FB Acc not exist") {
              store.showFacebookAndroid = true
            } else if (resp.data.error) {
              // console.log('err')
            } else {
              // console.log('err')
            }
          }
        }
        )
      }
    }
    window.androidAuthResult.error = () => {
      // alert('error')
    }

    /*******/
  },
  beforeDestroy() {
    // Забираємо обробник події, щоб уникнути витоків пам'яті
    document.removeEventListener('keydown', this.handleEscKey);
    document.removeEventListener('click', this.handleOutsideClick);
  },
  mounted() {
    // Додаємо обробник події 'keydown' для всієї сторінки
    document.addEventListener('keydown', this.handleEscKey);

    document.addEventListener('click', this.handleOutsideClick);

    keyevent.$off('enter');
    keyevent.$on('enter', () => {
      this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
    })
    //  androidFixMono('login');
    // Ініціалізація користувача гугл
    try {
      this.googleClient = google.accounts.oauth2.initTokenClient({
        client_id: '910811730153-q8m9pb2rkt372dlf3u3te7kggbhj3aiu.apps.googleusercontent.com',
        scope: 'email profile https://www.googleapis.com/auth/userinfo.email openid https://www.googleapis.com/auth/userinfo.profile',
        callback: (response) => {
          this.addGoogle(response.access_token);
        },
      });
    } catch (err) {
      // console.log("не вдалося ініціалізувати користувача гугл")
    }
    // Пишемо у службу підтримки
    setTimeout(() => {
      if (webviewCheck() == "android_webview") {
        this.showCrispButton = true
      } else {
        // Стартуємо чат підтримки
        window.$crisp.push(['do', 'chat:show']);
        $crisp.push(["on", "chat:opened", () => {
          // Адаптація чату для мобільного додатка ios iphone 10+
          // Визначаємо, що за девайс, чи є брова
          try {
            //Notch - виріз в екрані айфону
            let isNotch = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--sat"));
            if (isNotch > 0 && webviewCheck() == "ios_webview") {
              // Знаходимо перший елемент з атрибутом [data-mode][data-helpdesk-collapsed] (шапка чату) та задаємо стилі
              let firstElement = document.querySelector('.crisp-client #crisp-chatbox [data-mode][data-helpdesk-collapsed]');
              firstElement.parentElement.style = `padding-top: ${isNotch}px !important; background: #5db85b !important;`;
              // Задаємо стилі для елементу (тіла) чату
              document.querySelector('.crisp-client #crisp-chatbox [data-has-health][data-has-drop-zone][data-has-feedback] [data-visible]').style = `margin-bottom: ${isNotch}px !important;`
            }
          } catch (err) {
            console.log("нету моноброви");
          }
        }])
      }
    }, 200);
    if (webviewCheck() == 'ios_webview') {
      try {
        window.webkit.messageHandlers.getAppVersion.postMessage('');
      } catch (err) {
        // в додатку може не бути handler-а getAppVersion
        console.error(err);
      }
    }
  },
  methods: {
    handleOutsideClick(event) {
      const isInsideModal = event.target.closest('.company-modal');
      if (!isInsideModal) {
        this.showChoiceCompanyForm = false;
      }
    },
    // Дії при натиску на кнопку через apple
    signInWithApple() {
      if (this.hasAppleBridge) {
        this.signInWithAppleForIOSApp()
      } else if (webviewCheck() == 'browser') {
        this.signInWithAppleForBrowser()
      }
    },
    // Авторизація через apple для додатку на ios
    signInWithAppleForIOSApp() {
      window.webkit.messageHandlers.handleAppleSignIn.postMessage('');
    },
    // Авторизація через apple для браузера
    signInWithAppleForBrowser() {
      // Ініціалізація Apple Sign In
      window.AppleID.auth.init({
        clientId: "pro.skeservice.app",
        scope: 'name email', // Вказати необхідні області
        redirectURI: "https://auth.skyservice.online/",
        usePopup: true,
      });
      // Виклик методу для відображення вікна авторизації
      window.AppleID.auth.signIn()
        .then(response => {
          const appleToken = response.authorization.id_token;
          this.addApple(appleToken);
        })
        .catch(error => {
          console.error(error)
          window.say.messageError(this.lang['ErrorAppleLogin']);
        });
    },
    // Відправка данних на бек після авторизації через apple
    addApple(appleToken) {
      try {
        store.serviceAppleToken = appleToken;
        // Від Apple нам потрібний тільки токен який передаємо на бек
        const obj = {
          apple_token: appleToken,
          lang: store.lang,
        };
        apiList.authApple(obj).then((resp) => {
          console.warn("authApple_resp", resp);
          if (resp.data.status == "done") {
            if (resp.data.data.token) {
              this.goToCabinet(resp.data.data.token);
            } else if (resp.data.data.description === "Email is already registered") {
              this.showBindSocials = true;
              this.bindData = {
                socialType: "Apple",
                currentUserPhone: resp.data.data.user_phone,
                currentAccessToken: appleToken
              }
            }
          } else {
            if (resp.data.error == "Apple Acc not exist") {
              window.say.messageError(this.lang['AccountNotRegistered']);
              this.showLoginServiceApple = true;
            } else if (resp.data.error == "Phone is already registered") {
              this.showLoginServiceApple = true;
              window.say.messageError(this.lang['PhoneAlreadyRegistered']);
            } else {
              window.say.messageError(this.lang['ErrorAppleLogin']);
            }
          }
        });
      } catch (err) {
        // console.log(err);
        window.say.messageError(this.lang['ErrorAppleLogin']);
      }
    },
    // 2 методи для фокусу на сторінці, вони потрібні для кейівентів
    loginInputFocus() {
      try {
        this.$refs.loginInput.focus()
      } catch (err) {
        // console.log(err)
      }
    },
    loginRefFocus() {
      try {
        this.$refs.loginRef.focus()
      } catch (err) {
        // console.log(err)
      }
    },
    closeCaptcha() {
      this.showForgotCaptcha = false
      keyevent.$off('enter');
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    closeSmsModal() {
      this.showSms = false
      keyevent.$off('enter');
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    devMode() {
      this.showEmergencyEntrance = this.showEmergencyEntrance + 1;
      if (this.showEmergencyEntrance > 5) {
        this.showEmergencyEntrance = 0;
      }
    },
    closeLoginPass() {
      this.showLoginPass = false;
      this.loginRefFocus();
      keyevent.$off('enter');
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    openAuthModal(e) {
      this.closeTelegramModal();
      this.form.login = e;
      this.registered = true;
      this.showLoginPass = true;
      this.loginRefFocus();
      keyevent.$off('enter')
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    closeGoogleModal() {
      store.showGoogleAndroid = false;
      this.showLoginServiceGoogle = false;
      this.loginRefFocus();
      keyevent.$off('enter')
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    closeKepModal() {
      this.showLoginServiceKep = false;
      this.loginRefFocus();
      keyevent.$off('enter')
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    closeFacebookModal() {
      store.showFacebookAndroid = false;
      this.showLoginServiceFacebook = false;
      this.loginRefFocus();
      keyevent.$off('enter')
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    closeTelegramModal() {
      store.showTelegramAndroid = false;
      this.showLoginServiceTelegram = false;
      this.loginRefFocus();
      keyevent.$off('enter')
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    closeAppleModal() {
      this.showLoginServiceApple = false;
      this.loginRefFocus();
      keyevent.$off('enter')
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    closeBindModal() {
      this.showBindSocials = false;
      this.bindData = {
        socialType: '',
        currentUserPhone: '',
        currentAccessToken: '',
        facebookId: '',
        facebookToken: ''
      }
      this.loginInputFocus();
      keyevent.$off('enter')
      keyevent.$on('enter', () => {
        this.form.login.length > 3 ? this.btnLogin() : window.say.messageError(this.lang['EMailOrPhone'])
      })
    },
    googleWindowsAuth() {
      let data = {
        command: "auth",
        authType: "google"
      }

      var request = {
        method: "auth",
        data: JSON.stringify(data)
      }

      window.cefQuery({
        request: JSON.stringify(request),
        persistent: true,
        onSuccess: function (responseJson) {
          console.log(responseJson)
        },
        onFailure: function (error_code, error_message) {
          console.log(error_code, error_message)
        }
      });
    },
    facebookWindowsAuth() {
      let data = {
        command: "auth",
        authType: "facebook"
      }
      var request = {
        method: "auth",
        data: JSON.stringify(data)
      }

      window.cefQuery({
        request: JSON.stringify(request),
        persistent: true,
        onSuccess: function (responseJson) {
          console.log(responseJson)
        },
        onFailure: function (error_code, error_message) {
          console.log(error_code, error_message)
        }
      });
    },
    // Метод для авторизації андроїдів
    androidAuth(t) {
      let authData = {
        "command": 'auth', //logout
        "authType": t,
      }
      try {
        // eslint-disable-next-line
        Android.auth(JSON.stringify(authData))
      } catch (err) {
        console.log('err')
      }
    },
    telegramLogin() {
      if (webviewCheck() == "android_webview") {
        this.androidAuth(this.telegram)
      } else if(webviewCheck() == "cef_webview"){
        let request = {
          "method": "auth",
          "data": "{'command':'auth','authType':'telegram'}"
        }
        window.cefQuery({request: JSON.stringify(request),
        persistent: true,
        onSuccess: function(responseJson) {
          // console.log(responseJson)
        },
        onFailure: function(error_code, error_message) {
          // console.log(error_code, error_message)
        }
      });
      } else {
        window.Telegram.Login.auth({ bot_id: '1401730837', request_access: 'read' },
          (data) => {
            if (!data) {
              console.error("ErrorTelegramLogin")
            } else {
              console.log(data);
              this.telegramCallbackFunction(data);
            }
          }
        );
      }
    },
    // Варіант отримання токена гугл
    googleLogin() {
      if (webviewCheck() == "android_webview") {
        this.androidAuth(this.google)
      } else if (webviewCheck() == "cef_webview") {
        this.googleWindowsAuth()
      } else if (webviewCheck() == "ios_webview") {
        window.webkit.messageHandlers.GoogleAuth.postMessage("");
      } else {
        this.googleClient.requestAccessToken();
      }
    },
    // Забув пароль-телефон
    // Відкриваємо вікно для введення капчі, якщо користувач ввів номер телефону як логін
    goToCaptch() {
      this.showForgotCaptcha = true;
    },
    goDemo() {
      moreURLs.authToDemo(store.lang).then((resp) => {
        if (resp.data.status == "done" && resp.data.data.authTerminal == true) {
          apiCookies.set("token", resp.data.data.token, { expires: 180 });//, {domain: ".skyservice.online"}
          let url = ''
          url = resp.data.data.url
          document.location.href = url;
          this.showLoginPass = false
        } else if (resp.data.status == "done") {
          // Якщо передано токен, тоді авторизація пройшла успішно і користувач іде далі
          if (resp.data.data.token) {
            
            // Записуюмо токе
            // Редиректим користувача на сторінку персони
            this.showLoginPass = false;
            this.goToCabinet(resp.data.data.token);
          } else {
            // Якщо пройшла авторизація не успішно, тоді будемо
            // передавати дані про кількість спроб, що залишилися, на спроби входу
            if (resp.data.data.countsLeft > 0) {
              window.say.messageError(this.lang['InvalidPassNumberOfAttemptsToCheckAuth'] + ' ' + resp.data.data.countsLeft);
            }
            // Якщо пройшла авторизація не успішно, тоді будемо
            // передавати дані про кількість спроб, що залишилися, на спроби входу
            if (!resp.data.data.canAuth) {
              window.say.messageError(this.lang['TryAgainAfterMinute']);
            }
          }
        } else {
          if (resp.data.error[0] == "login is incorrect") {
            window.say.messageError(this.lang['WrongLoginOrPassword']);
          } else if (resp.data.error[0] == "pass is incorrect") {
            window.say.messageError(this.lang['WrongLoginOrPassword']);
          } else if (resp.data.error[0] == "wrong terminal password") {
            window.say.messageError(this.lang['WrongLoginOrPassword']);
          } else {
            window.say.messageError(this.lang['Error']);
          }
        }
      });
    },
    goEmergencyEntrance() {
      location.href = moreURLs.goEmergencyEntrance(store.lang);
    },
    getSms() {
      this.showSms = true;
    },
    // Телеграм логін
    telegramCallbackFunction(user) {
      console.warn('tg user data', user)
      return new Promise((resolve, reject) => {
        if (user != null) {
          resolve(user);
        } else {
          reject();
        }
      })
        .then((user) => {
          try {
            this.serviceTgData = user
            apiList
              .authTelegram({
                ...user,
                lang: store.lang,
              })
              .then((resp) => {
                if (resp.data.status == "done") {
                  this.goToCabinet(resp.data.data.token);
                } else {
                  if (resp.data.error == "Telegram acc is not registered") {
                    window.say.messageError(this.lang['AccountNotRegistered']);
                    this.showLoginServiceTelegram = true
                  } else {
                    window.say.messageError(this.lang['ErrorTelegramLogin']);
                  }
                }
              });
          } catch (err) {
            console.log(err)
            window.say.messageError(this.lang['ErrorTelegramLogin']);
          }
        })
        .catch((err) => {
          window.say.messageError(this.lang['ErrorTelegramLogin']);
        });
    },
    // login ФБ
    facebookLogin() {
      if (webviewCheck() == "android_webview") {
        this.androidAuth(this.facebook)
      } else if (webviewCheck() == "ios_webview") {
        window.webkit.messageHandlers.FacebookAuth.postMessage("");
      } else if (webviewCheck() == "cef_webview") {
        this.facebookWindowsAuth()
      } else {
        FB.login((login) => {
          console.log(login)
          try {
            if (login.status == "connected") {
              try {
                // нам ФБ віддає токен і ід користувача, який перевіряється на беку і якщо всі ок то ми входимо
                store.serviceFacebookToken = login.authResponse.accessToken
                store.serviceUserID = login.authResponse.userID
                const obj = {
                  id: login.authResponse.userID,
                  token: login.authResponse.accessToken,
                  lang: store.lang,
                };
                apiList.authFB(obj).then((resp) => {
                  if (resp.data.status == "done") {
                    if (resp.data.data.description == "Email is already registered") {
                      this.showBindSocials = true;
                      this.bindData = {
                        socialType: "Facebook",
                        currentUserPhone: resp.data.data.user_phone,
                        facebookToken: obj.token,
                        facebookId: obj.id
                      }
                    } else {
                      // Якщо все ок:
                      // Записуємо токен
                      // Редиректим користувача на сторінку персони
                      this.goToCabinet(resp.data.data.token);
                    }

                  } else {
                    if (resp.data.error == "FB Acc not exist") {
                      window.say.messageError(this.lang['AccountNotRegistered'])
                      this.showLoginServiceFacebook = true
                    } else {
                      window.say.messageError(this.lang['ErrorFacebookLogin']);
                    }
                  }
                });
              } catch (err) {
                window.say.messageError(this.lang['ErrorFacebookLogin']);
              }
            }
          } catch (err) {
            // console.log(err);
          }
        })
      }
    },
    /**
     * обычная форма логина
     */
    btnLogin() {
      if (this.form.login.length > 3) {
        this.checkAcc()
        //!this.showLoginPass
      } else {
        window.say.messageError(this.lang['EMailOrPhone']);
      }
    },
    // Приймаємо пароль з модалки впихаємо його у форму після викликаємо метод логіну
    sendPass(i) {
      this.form.password = i;
      this.goLogin();
    },
    // Метод перевірки облікового запису на наявність онного
    checkAcc() {
      try {
        try {
          //Костильчик для України що б не вводити +38
          if (this.form.login["0"] == "0") {
            this.form.login = "38" + this.form.login
          }
        } catch (err) {
          console.error(err)
        }

        apiList.checkAccount({ login: this.form.login }).then(resp => {
          if (resp.data.status == "done") {
            if (resp.data.data == 'login not found' || resp.data.data == 'login found, not full reg') {
              this.registered = false;
              this.showLoginPass = true;
            } else {
              this.registered = true;
              this.showLoginPass = true;
              // Якщо пройшла авторизація не успішно, тоді будемо
              // Передавати дані про кількість спроб, що залишилися, на спроби входу
              if (!resp.data.data.auth.canAuth) {
                // Перевіряємо на кількість спроб
                if (resp.data.data.auth.countsLeft > 0) {
                  window.say.messageError(this.lang['numberOfAttemptsToCheckAuth'] + ' ' + resp.data.data.auth.countsLeft);
                } else {
                  // інакше повторіть спробу пізніше
                  // this.$emit('tryLater'); 
                  window.say.messageError(this.lang['TryAgainAfterMinute']);
                }
              }
            }
          } else if (resp.data.status == "error") {
            this.$emit('close');
            if (Array.isArray(resp.data.error)) {
              for (let key in resp.data.error) {
                window.say.messageError(resp.data.error[key]);
              }
            } else if (typeof resp.data.error == 'string') {
              window.say.messageError(resp.data.error);
            }
          } else {
            this.$emit('close');
            this.registered = false;
            window.say.messageError("unknown error:0175");
          }

        })
      } catch (err) {
        // console.log(err)
      }
    },
    handleEscKey(event) {
      if (event.key === 'Escape') {
        this.form.password = '';
        this.showLoginPass = false;
        this.showChoiceCompanyForm = false;

        apiCookies.remove('token', { path: '/' });

      }
    },

    // Метод логіна набуває форми, логін заповнюється у цьому компоненті, а пароль прилітає з модалки
    goLogin() {
      // const expirationDate = new Date()
      // expirationDate.setMonth(expirationDate.getMonth() + 6);
      try {
        (this.form.lang = store.lang),
          apiList.personLogin(this.form).then((resp) => {
            if (resp.data.status == "done" && resp.data.data.authTerminal == true) {
              apiCookies.set("token", resp.data.data.token, { expires: 180 });//, {domain: ".skyservice.online"}
              let url = ''
              url = resp.data.data.url
              document.location.href = url;
              this.showLoginPass = false
            } else if (resp.data.status == "done") {
              // Якщо передано токен, тоді авторизація пройшла успішно і користувач іде далі
              if (resp.data.data.token) {
                localStorage.setItem("user_login", this.form.login);
                // Записуюмо токе
                // Редиректим користувача на сторінку персони
                this.showLoginPass = false;
                this.goToCabinet(resp.data.data.token);
              } else {
                // Якщо пройшла авторизація не успішно, тоді будемо
                // передавати дані про кількість спроб, що залишилися, на спроби входу
                if (resp.data.data.countsLeft > 0) {
                  window.say.messageError(this.lang['InvalidPassNumberOfAttemptsToCheckAuth'] + ' ' + resp.data.data.countsLeft);
                }
                // Якщо пройшла авторизація не успішно, тоді будемо
                // передавати дані про кількість спроб, що залишилися, на спроби входу
                if (!resp.data.data.canAuth) {
                  window.say.messageError(this.lang['TryAgainAfterMinute']);
                }
              }
            } else {
              if (resp.data.error[0] == "login is incorrect") {
                window.say.messageError(this.lang['WrongLoginOrPassword']);
              } else if (resp.data.error[0] == "pass is incorrect") {
                window.say.messageError(this.lang['WrongLoginOrPassword']);
              } else if (resp.data.error[0] == "wrong terminal password") {
                window.say.messageError(this.lang['WrongLoginOrPassword']);
              } else {
                window.say.messageError(this.lang['Error']);
              }
            }
          });
      } catch (err) {
        window.say.messageError(this.lang['Error']);
      }
    },

    // Логін вхід через Гугл
    addGoogle(token) {
      try {
        // Від гугла нам потрібний тільки токен який передаємо на бек
        store.serviceGoogleToken = token
        const obj = {
          token,
          lang: store.lang,
        };
        apiList.authGoogle(obj).then((resp) => {
          console.log(resp);
          if (resp.data.status == "done") {
            if (resp.data.data.token) {
              this.goToCabinet(resp.data.data.token);
            } else if (resp.data.data.description === "Email is already registered") {
              this.showBindSocials = true;
              this.bindData = {
                socialType: "Google",
                currentUserPhone: resp.data.data.user_phone,
                currentAccessToken: obj.token
              }
            }
          } else {
            if (resp.data.error == "Google Acc not exist") {
              window.say.messageError(this.lang['AccountNotRegistered']);
              this.showLoginServiceGoogle = true;
            } else if (resp.data.error == "Phone is already registered") {
              this.showLoginServiceGoogle = true;
              window.say.messageError(this.lang['PhoneAlreadyRegistered']);
            } else {
              window.say.messageError(this.lang['ErrorGoogleLogin']);
            }
          }
        });
      } catch (err) {
        // console.log(err);
        window.say.messageError(this.lang['ErrorGoogleLogin']);
      }
    },
    // Вхід за КЕП: provider — 'diia' | 'smartid' (ПриватБанк) | 'file' (файловий ключ)
    async kepLogin(provider) {
      try {
        const challengeResp = await apiList.kepChallenge();
        if (challengeResp.data.status != "done") throw new Error(challengeResp.data.error);

        const signed = await signKepChallenge(challengeResp.data.data.challenge, provider);

        const resp = await apiList.authKep(signed);
        if (resp.data.status != "done") throw new Error(resp.data.error);

        if (resp.data.data.token) {
          this.goToCabinet(resp.data.data.token);
        } else {
          // КЕП ще не прив'язаний — просимо увійти як раніше, прив'яжемо в goToCabinet
          this.setKepPending(resp.data.data.kep_ticket, resp.data.data.kep_name, resp.data.data.expires_in);
          this.loginRefFocus();
        }
      } catch (err) {
        console.error('[KEP] вхід через', provider, err && err.code, err);
        if (!isKepSilentError(err)) {
          window.say.messageError(this.lang['ErrorKepLogin']);
        }
      }
    },
    // Тікет КЕП живе обмежений час: коли сплине — ховаємо підказку, щоб не прив'язувати простроченим
    setKepPending(ticket = '', name = '', expiresIn = 600) {
      clearTimeout(this.kepPendingTimer);
      this.kepPending = { ticket, name };
      if (ticket) {
        this.kepPendingTimer = setTimeout(() => this.setKepPending(), (expiresIn - 30) * 1000);
      }
    },
    // Просто пушим користувача на сторінці реєстрації
    goReg() {
      keyevent.$off('enter')
      this.$router.push("/registration");
    },
    // Зміна мови
    changeLang(l) {
      localStorage.setItem("lang_user", l);
      store.lang = l;
      window.lang = store.langs[store.lang]();
    },
    async goToCabinet(token) {
      if (token != null) {
        apiCookies.set("token", token, { expires: 180 })
      }

      // після входу будь-яким способом прив'язуємо КЕП, яким намагалися увійти
      if (this.kepPending.ticket) {
        const ticket = this.kepPending.ticket;
        this.setKepPending();
        try {
          const resp = await apiList.addKepByTicket({ token: token || Cookies.get("token"), kep_ticket: ticket });
          if (resp.data.status == "done") {
            window.say.message(this.lang['KepLinked']);
          } else {
            console.error('[KEP] прив\'язка після входу', resp.data.error);
            window.say.messageError(this.lang['KepLinkFailed']);
          }
        } catch (err) {
          console.error('[KEP] прив\'язка після входу', err);
          window.say.messageError(this.lang['KepLinkFailed']);
        }
      }

      try {
        // Перехват token з адмінки
        const inParams = new URLSearchParams(location.search);
        // Якщо вказано, що треба виходити, то не відкриваємо список
        const isLogout = inParams.get('logout');

        if (isLogout) {
          // Чекаємо поки буде вихід
        } else {
          this.showChoiceCompanyForm = true;
        }
      } catch (err) {
        this.showChoiceCompanyForm = true;
      }
    }
  },
  computed: {
    // "Іван Петренко, ваш КЕП ще не прив'язаний…" або з великої літери, якщо ПІБ немає
    kepPendingText() {
      const text = this.lang['KepNotLinked'];
      return this.kepPending.name
        ? this.kepPending.name + ', ' + text
        : text.charAt(0).toUpperCase() + text.slice(1);
    },
    // Нативний міст Apple Sign In доступний тільки в iOS-додатку, який готовий його обробити
    hasAppleBridge() {
      return !!(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.handleAppleSignIn);
    },
    appleSign() {
      return this.hasAppleBridge || webviewCheck() == 'browser';
    },
    loginState() {
      return this.form.login != '' && this.form.login.length >= 4 ? true : false;
    },
    serviceGoogleToken() {
      return store.serviceGoogleToken;
    },
    serviceFacebookToken() {
      return store.serviceFacebookToken;
    },
    serviceAppleToken() {
      return store.serviceAppleToken;
    },
    serviceFacebookUserID() {
      return store.serviceUserID;
    },

    showGoogleAndroid() {
      return store.showGoogleAndroid
    },
    showFacebookAndroid() {
      return store.showFacebookAndroid
    },
    showTelegramAndroid() {
      return store.showTelegramAndroid
    },
    lang() {
      return store.langs[store.lang]();
    },
  },
};
</script>

<style>
a:hover {
  color: inherit;
  text-decoration: none;
}

.login-page {
  display: flex;
  flex-flow: row;
}

.login-left {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-y: auto;
}

.left-content {
  margin: 15px 20px;
  width: 100%;
}

.header-login {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 70px;
}

.header-login .logo {
  width: 60%;
}

.login-right {
  height: 100vh;
  padding: 50px 30px 0;
  width: 50%;
  /* background-color: #00C279; */
  display: none;
}

.title {
  /* font-family: 'Proxima Nova'; */
  /* font-weight: 700; */
  font-size: 45px;
  line-height: 108%;
  max-width: 600px;
  margin-bottom: 40px;
  color: #484848;
}

.image {
  width: 100%;
  max-width: 535px;
  margin-bottom: 35px;
}

.mockup {
  margin-bottom: 35px;
  position: relative;
}

.image-pad {
  max-width: 385px;
}

.image-phone {
  max-width: 120px;
  position: absolute;
  top: 80px;
  left: 355px;
}

.content-text {
  max-width: 600px;
  color: #484848;
  /* font-family: 'Montserrat'; */
  font-size: 16px;
  white-space: pre-line;
}

#login {
  position: relative;
}

.form-control.is-valid {
  border-color: #00C279;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300C279' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e");
}

/* .container {
  overflow-y: auto;
} */

 .form-control.is-invalid {
  border-color: #ff3548;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ff3548' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
 }

.privacy-policy-term {
  color: #007BFF;
  font-weight: 500;
  font-size: 12px;
}

.privacy-policy-term:hover {
  color: #007BFF;
  text-decoration: underline;
}

.langSelector {
  float: right;
}

label {
  margin-bottom: 15px;
}

.enter-text {
  /* font-family: 'Montserrat';  */
  font-size: 15px;
}

.welcome-semibold {
  font-weight: 600;
}

.input {
  height: 45px;
  margin-bottom: 15px !important;
}

.input::placeholder {
  color: #989898;
}


.loginButton {
  width: 100%;
  height: 45px;
  background-color: #00C279;
  border: none;
  border-radius: 5px;
  color: white;
  /* font-family: 'Montserrat'; */
  font-weight: 500;
  margin-bottom: 50px;
}

.loginButton:hover {
  background-color: #00B26F;
  color: white;
}

.enter-with-text {
  /* font-family: 'Montserrat'; */
  font-size: 15px;
  text-align: center;
}

.network-img {
  width: 50px;
  height: 50px;
}

#enterWidth {
  margin-bottom: 20px;
}

#tg-container {
  opacity: 0;
  position: absolute;
  width: 100%;
  bottom: 5px;
  z-index: 1;
  overflow: hidden;
}

.login-text-btn {
  display: flex;
  justify-content: space-between;
}

/* соцмережі + КЕП (до 6 іконок) в один рядок на будь-якій ширині */
.network-div-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  max-width: 370px;
  margin: 0 auto 50px;
}

.network-div .btn {
  padding: 5px;
}

.network-div .network-img,
.network-div .apple-btn {
  width: 36px;
  height: 36px;
}

/* підказка: КЕП ще не прив'язаний */
.kep-pending {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 15px;
  padding: 10px 12px;
  border: 1px solid #00c279;
  border-radius: 10px;
  font-size: 14px;
}

.kep-pending-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.kep-pending-link {
  color: #00c279;
  font-weight: 600;
  cursor: pointer;
}

.kep-pending-close {
  font-size: 20px;
  line-height: 1;
  color: #888;
  cursor: pointer;
}

/* ключ файлового КЕП: потрушування при наведенні */
.kep-key {
  transform-origin: center center;
}

.network-div .btn:hover .kep-key {
  animation: kep-key-shake 0.6s ease;
}

@keyframes kep-key-shake {
  0%, 100% { transform: translate(0) rotate(0deg); }
  15% { transform: translate(-3px) rotate(-12deg); }
  30% { transform: translate(3px) rotate(10deg); }
  45% { transform: translate(-2px) rotate(-8deg); }
  60% { transform: translate(2px) rotate(6deg); }
  75% { transform: translate(-1px) rotate(-3deg); }
}

@media (prefers-reduced-motion: reduce) {
  .network-div .btn:hover .kep-key {
    animation: none;
  }
}

/* .network-div {
  padding: 0 15px;
} */

.network-div .btn {
  border-radius: 10px;
  transition: transform 0.25s;
}

.network-div .btn:hover {
  background: rgb(245, 245, 245);
  transform: scale(1.1);
}

.apple-btn {
  width: 50px;
  height: 50px;
  position: relative;
  top: -3px;
}

.v-facebook-login {
  padding: 10px 15px;
}

.help {
  color: #228311;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 1rem;
  margin-left: 2rem;
}

.fb_text {
  display: none;
}

.fb_logo {
  font-size: 0rem;
}

/* .login-container {
  padding: 0 15px;
} */

/* .login-form-container {
  padding: 15px;
} */

.registration-demo {
  display: flex;
  flex-flow: column;
  align-items: center;
  gap: 5px;
}

.go-registration {
  color: black;
  cursor: pointer;
  font-size: 15px;
  text-align: center;
}

.go-registration-link {
  color: #007BFF;
  font-weight: 500;
}

.go-registration-link:hover {
  color: #007BFF;
  text-decoration: underline;
}

.emergency-entrance-span {
  color: black;
  margin-left: 2rem;
  text-decoration: underline;
  cursor: pointer;
}

.demo-span {
  font-size: 15px;
  color: #ff5c6c;
  font-weight: 500;
  cursor: pointer;
}

.demo-span:hover {
  color: #ff5c6c;
  text-decoration: underline;
}

#footerLinks {
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 20px;
  font-size: 9pt;
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

@media screen and (min-width: 420px) {
  .header-login .logo {
    width: auto;
  }
}

@media screen and (max-height: 510px) {
  #footerLinks {
    position: relative;
    margin-top: 2rem;
  }
}

@media screen and (max-width: 700px) {
  .sky-img {
    width: 100%;
  }

  .login-container {
    padding: 0;
  }

  .network-div {
    text-align: center;
  }

  .demo-span {
    margin-left: unset;
    display: block;
  }

  .emergency-entrance-span {
    margin-left: unset;
    margin-top: 2rem;
    display: block;
  }
}

@media screen and (min-width: 576px) {
  .left-content {
    max-width: 536px;
  }
}

@media screen and (min-width: 768px) {
  .login-left {
    align-items: center;
  }

  /* #loginContainerBox {
    background: linear-gradient(-44deg, rgb(225 255 221) 0%, rgb(208 230 255) 100%);
  } */

  #loginContainerBox {
    background:
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' transform='rotate(-30 7 8)' viewBox='0 0 14 16' width='50'%3E%3Cpath fill='%23eee' d='M.377 13.484h8.466c1.374 0 1.439-1.092 1.439-1.596 0-.586-.152-1.257-1.483-1.655L2.776 8.41c-.239-.063-1.199-.377-1.81-1.091C.268 6.521.181 5.369.181 4.55c0-.881.109-1.95.981-2.727.785-.711 1.768-.818 2.51-.818h8.792v2.203H4.653c-.392 0-.851.021-1.199.336-.371.335-.392.859-.392 1.132 0 .651.196 1.279 1.417 1.657l5.585 1.699c1.024.315 1.724.63 2.181 1.048.917.839 1.004 2.141 1.004 2.831 0 .923-.131 1.952-.763 2.729-.764.943-1.724 1.047-2.727 1.047H.377v-2.203z'/%3E%3C/svg%3E"),
    linear-gradient(184deg, rgb(211, 211, 211) 0%, rgb(240, 240, 240) 80%);
    background-repeat: repeat;
    background-size: cover;
    background-position: center, center;
  }

  .left-content {
    max-width: 430px;
    padding: 30px;
    border-radius: 12px;
    background-color: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }


  .login-right {
    /* display: flex; */
    display: none;
    justify-content: center;
    align-items: center;
  }

  .header-login {
    margin-bottom: 60px;
  }

  .input {
    height: auto;
  }

  .loginButton {
    height: auto;
  }

  .network-img {
    width: auto;
    height: 50px;
  }

  .apple-btn {
  width: auto;
  height: 50px;
}

  /* label {
    margin-bottom: 25px;
  } */

  /* .enter-with-text {
    text-align: start;
  } */

  /* .network-div-container {
    justify-content: flex-start;
  } */

}

@media screen and (min-width: 1200px) {
  .login-left {
    /* width: 50%; */
    display: flex;
    align-items: center;
  }

  .left-content {
    margin: 0;
  }

  .login-right {
    display: none;
    /* display: flex; */
    justify-content: center;
  }

  .header-login {
    margin-bottom: 60px;
  }

  /* label {
    margin-bottom: 25px;
  } */

  /* .enter-with-text {
    text-align: start;
  } */

  /* .network-div-container {
    justify-content: flex-start;
  } */

  .registration-demo {
    margin-bottom: 0;
  }
}
</style>
